import { PJAxios, usePJStore } from '@jaf/jaf-react-core';
import React, { useEffect, useRef, useState } from 'react';
import './NodeWindow.css';

import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';

import { Toast } from 'primereact/toast';

import { InputSwitch } from 'primereact/inputswitch';
import { ProgressSpinner } from 'primereact/progressspinner';
import { flushCache } from '../../../api/ChatbotApi';


function NodeWindow(props) {


    const [openDt, setOpenDt] = useState(null);
    const [closeDt, setCloseDt] = useState(null);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);

    const [modifiedNodes, setModifiedNodes] = useState([]);

    const getText = usePJStore((state) => state.i18n_getText)
    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const { storage } = usePJStore((state) => state.storage)

    useEffect(() => {

        setOpenDt(null);
        setCloseDt(null);

        var url = '/gestioneConfigurazioni/getNodeWindow/' + props.selectedNode.idNode;
        PJAxios().get(url).then((res) => {

            if (res.data.openDt) {
                setOpenDt(new Date(res.data.openDt));
            }
            if (res.data.closeDt) {
                setCloseDt(new Date(res.data.closeDt));
            }

        });
    }, [props.selectedNode]);

    const salvaTutto = () => {
        setLoading(true);
        PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: modifiedNodes, idConfig: props.tematica.id_config }).then((res) => {
            props.onSave(props.tematica, true);
            setModifiedNodes([]);
            setLoading(false);
            flushCache(dbTest);
        });
    }


    const showValidationError = () => {
        toast.current.show({ severity: 'info', summary: getText("WARNING"), detail: getText("CHECK_DATE_WARNING") });
    }

    const isVisibleNode = (node) => {
        return !node.hidden;
    }

    const isHiddenNode = (node) => {
        return node.hidden
    }

    const resetNodeWindow = () => {
        setOpenDt(null);
        setCloseDt(null);
    }

    const updateNodeWindow = () => {

        var d1 = new Date(openDt);
        var d2 = new Date(closeDt);

        var valid = openDt != null && closeDt != null && d1.getTime() < d2.getTime();
        //valid = valid || (openDt === null && closeDt != null && d2.getTime() > (new Date().getTime() - 60000));
        //valid = valid || (openDt != null && closeDt === null);
        valid = valid || (openDt === null && closeDt === null);

        if (valid) {
            PJAxios().post('/gestioneConfigurazioni/updateNodeWindow', { openDt: openDt, closeDt: closeDt, selectedNodeId: props.selectedNode.idNode }).then((res) => {
                props.onNodeWindowUpdate(res.data);
                flushCache(dbTest);
            });
        } else {
            showValidationError();
        }
    }

    const mostraNodo = () => {
        setModifiedNodes([]);

        var item = {
            is_new: false,
            id_element: "Q" === props.selectedNode.nodeType ? "nascondifaq" : "M" === props.selectedNode.nodeType ? "nascondiramo" : "D" === props.selectedNode.nodeType ? "nascondidest" : "S" === props.selectedNode.nodeType ? "nascondilink" : "",
            id_item: props.selectedNode.idItem,
            new_val: false,
            obj_type: "Q" === props.selectedNode.nodeType ? "itemFaq" : "M" === props.selectedNode.nodeType ? "menu" : "S" === props.selectedNode.nodeType ? "itemLink" : "",
            op_type: "mod_el"
        }

        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)
        salvaTutto();
    }

    const nascondiNodo = () => {
        setModifiedNodes([]);

        var item = {
            is_new: false,
            id_element: "Q" === props.selectedNode.nodeType ? "nascondifaq" : "M" === props.selectedNode.nodeType ? "nascondiramo" : "D" === props.selectedNode.nodeType ? "nascondidest" : "S" === props.selectedNode.nodeType ? "nascondilink" : "",
            id_item: props.selectedNode.idItem,
            new_val: true,
            obj_type: "Q" === props.selectedNode.nodeType ? "itemFaq" : "M" === props.selectedNode.nodeType ? "menu" : "S" === props.selectedNode.nodeType ? "itemLink" : "",
            op_type: "mod_el"
        }

        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)
        salvaTutto();
    }

    return (
        <>

            {loading &&
                <ProgressSpinner />
            }

            {!loading &&
                <>

                    <div className="formgrid grid">
                        <div className="col-12">
                            <p style={{ textAlign: "left" }}>{getText("MODIFICA_RANGE_APERTURA_SUBTITLE")}</p>
                            <br />

                            <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("MODIFICA_RANGE_APERTURA_TITLE")}</b></h6></span>

                            <div className="formgroup-inline">
                                <div className="field col-3 md:col-3">
                                    {getText("DATA_APERTURA")}
                                    <Calendar
                                        id="openDt"
                                        value={openDt}
                                        onChange={(e) => setOpenDt(e.value)}
                                        dateFormat="dd-mm-yy"
                                        yearNavigator
                                        monthNavigator
                                        yearRange="2000:2100"
                                    />
                                </div>
                                <div className="field col-3 md:col-3">
                                    {getText("DATA_CHIUSURA")}
                                    <Calendar
                                        id="closeDt"
                                        value={closeDt}
                                        onChange={(e) => setCloseDt(e.value)}
                                        dateFormat="dd-mm-yy"
                                        yearNavigator
                                        monthNavigator
                                        yearRange="2000:2100"
                                    />
                                </div>
                            </div>
                            <div className="formgroup-inline">

                                <div className=" col-2 md:col-2">
                                    <Button style={{ width: "100%" }} icon="pi pi-save" onClick={updateNodeWindow}>{getText("SALVA")}</Button>
                                </div>
                                <div className=" col-2 md:col-2">
                                    <Button style={{ width: "100%" }} icon="pi pi-undo" onClick={resetNodeWindow}>{getText("RESET")}</Button>
                                </div>
                            </div>

                        </div>
                        <div className="col-12">&nbsp;</div>
                        <div className="col-12">&nbsp;</div>
                        <div className="col-12">
                            <p style={{ textAlign: "left" }}>{getText("NASCONDI_PERIODO_DETAIL")}</p>
                        </div>
                        <div className="col-12">
                            <p>&nbsp;</p>
                            {getText("LBL_NASCONDI")}
                            <InputSwitch checked={!isHiddenNode(props.selectedNode) ? false : true} onChange={isHiddenNode(props.selectedNode) ? mostraNodo : nascondiNodo} />

                            {/*<Card className='surface-card' title="Scelte Rapide">
                        <div className="formgroup-inline">
                            <div className="field col-3 md:col-3">
                                <Button className='stretch' onClick={closeNow}>{getText("CHIUSURA_IMMEDIATA")}</Button>
                            </div>
                            <div className="field col-3 md:col-3">
                                <Button className='stretch' onClick={openEternal}>{getText("APERTURA_IMMEDIATA")}</Button>
                            </div>
                        </div>
    </Card> */}
                        </div>
                    </div>

                    <div className="p-fluid grid formgrid col-6">
                        <Toast ref={toast}></Toast>
                    </div>
                </>
            }
        </>
    )
}

export default NodeWindow
